import React from "react";
import history from "../history";

import { connect } from "react-redux";
import { signout } from "../modules/signin/actions";
import { RootState } from "../modules/types";
import { User } from "../modules/session/types";
import { BrowserView, MobileView } from "react-device-detect";
import Tooltip from "./Tooltip";
import { getUnreadCount } from "../modules/SiteHeader/actions";
import { setMobileMessagingScrollTop } from "../modules/messaging/actions";

interface StoreProps {
  loading: boolean;
  user: User | null;
  isEmbeddedSession: boolean;
  currentPath: string;
  showNewMessage: boolean;
  fireUnreadCount: boolean;
}

interface DispatchProps {
  signout: () => void;
  getUnreadCount: () => void;
  setMobileMessagingScrollTop: (scrollTop: number) => void;
}

interface OwnState {
  showNavigationButtons: boolean;
  showHeader: boolean;
}

type Props = DispatchProps & StoreProps;

class SiteHeader extends React.PureComponent<Props, OwnState> {
  private dontShowRoutes: string[] = ["/", "/changeOrganization/"];

  public constructor(props: Props) {
    super(props);

    this.state = {
      showNavigationButtons: false,
      showHeader:
        !this.props.currentPath.includes("/message/") ||
        this.props.currentPath.includes("/patient/")
    };
  }

  private showButtons = (): boolean => {
    return !!this.props.user;
  };

  componentDidUpdate = () => {
    if (
      this.props.currentPath.includes("/message/") &&
      !this.props.currentPath.includes("/patient/")
    ) {
      this.setState({
        showNavigationButtons: false
      });
    } else {
      this.setState({
        showNavigationButtons: this.dontShowRoutes.indexOf(this.props.currentPath) == -1
      });
    }
    if (this.props.fireUnreadCount) this.props.getUnreadCount();
  };

  private mobileMessagingNavigation = () => {
    history.push("/messaging/");
    this.props.setMobileMessagingScrollTop(0);
  };

  public render() {
    const { user, signout } = this.props;
    const { showNavigationButtons } = this.state;

    const name = user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : null;

    return (
      <>
        {this.state.showHeader && (
          <div className="site-header noselect">
            <BrowserView viewClassName="flex">
              <div className="width-restrict flex">
                <div className="back-button-container">
                  {showNavigationButtons && (
                    <div className="nav-icons fade">
                      <div>
                        <Tooltip title={"Patient List"} position={"bottom"}>
                          <div className="circle" onClick={() => history.push("/dashboard/")}>
                            <i className="far fa-list-alt"></i>
                          </div>
                        </Tooltip>
                      </div>
                      <div className="ml-10 mr-10">
                        <Tooltip title={"Messaging"} position={"bottom"}>
                          <div className="circle" onClick={() => history.push("/messaging/")}>
                            <i className="far fa-envelope"></i>
                            {this.props.showNewMessage && <div className="new">NEW</div>}
                          </div>
                        </Tooltip>
                      </div>
                      <div>
                        <Tooltip title={"Virtual Waiting Room"} position={"bottom"}>
                          <div className="circle" onClick={() => history.push("/appointments/")}>
                            <i className="far fa-calendar-check"></i>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </div>

                {!this.props.isEmbeddedSession && (
                  <>
                    <div className="site-title">PerfectServe Reach</div>

                    <div className="flex-1 flex-end">
                      {this.showButtons() && (
                        <button className="btn-link sign-out ellipsis" onClick={signout}>
                          {name ? `Sign Out | ${name}` : `Sign Out`}
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </BrowserView>
            <MobileView viewClassName="mobile-header flex-between">
              {showNavigationButtons && (
                <div className="nav-icons fade">
                  <div>
                    <div className="circle" onClick={() => history.push("/dashboard/")}>
                      <i className="far fa-list-alt"></i>
                    </div>
                  </div>
                  <div className="ml-10">
                    <div className="circle" onClick={() => this.mobileMessagingNavigation()}>
                      <i className="far fa-envelope"></i>
                      {this.props.showNewMessage && <div className="new">NEW</div>}
                    </div>
                  </div>
                </div>
              )}

              {!this.props.isEmbeddedSession && (
                <>
                  <div className="site-title">PerfectServe Reach</div>

                  {this.showButtons() && (
                    <button className="btn-link sign-out" onClick={signout}>
                      Sign out
                    </button>
                  )}
                </>
              )}
            </MobileView>
          </div>
        )}
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.signin.loading,
    user: state.session.data.currentUser,
    isEmbeddedSession: state.session.data.isEmbeddedSession,
    currentPath: state.router.location.pathname,
    showNewMessage: state.pubnub.message.showNewMessage,
    fireUnreadCount: state.pubnub.message.fireUnreadCount
  }),
  {
    signout,
    getUnreadCount,
    setMobileMessagingScrollTop
  }
)(SiteHeader);
